import React, { Component, Fragment } from 'react';
import qs from 'query-string';
import SectionSelector from './SectionSelector';
import ProgressHeader from './ProgressHeader';
import Progress from './Progress';

class ApplyContainer extends Component {
  constructor(props) {
    super(props);

    const fromUber = props.location.state && props.location.state.formStep;
    const currentStep =
      fromUber && ['subscribed', 'lead'].includes(props.currentUser.status)
        ? props.location.state.formStep
        : 6;
    const progressPage = !(
      [
        'signed_up',
        'account_pending',
        'fleet_pending',
        'tlc_pending'
      ].includes(props.currentUser.status) || fromUber
    );

    this.state = {
      uberTerms: false,
      currentStep,
      progressPage,
      progressMessage: continueMessage,
      progressTitle: 'Application',
      progress: {
        steps: [],
        nextStep: 0,
        started: false
      },
      bypassTlc: false,
      done: false // check if sign up steps 1-4 are done
    };
  }

  targetElement = null;

  componentDidMount() {
    this.updateProgress();
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentUser !== prevProps.currentUser) {
      this.updateProgress();
    }
  }

  toggleUberTerms = () =>
    this.setState({ uberTerms: !this.state.uberTerms });

  goToSaved = () => {
    this.props.refetch();
    this.setState({
      progressPage: true,
      progressMessage: 'Your progress has been saved!',
      progressTitle: 'Saved'
    });
  };

  goToUberTerms = () => this.setState({ currentStep: 0, uberTerms: true });

  setStep = step => {
    if (step <= 5 || step >= 0) {
      this.setState({ currentStep: step });
    }
  };

  incrementStep = () => {
    const { currentStep, progress } = this.state;
    if (currentStep === 4) {
      if (progress.nextStep !== 5) {
        this.setState({
          progressPage: true,
          progressMessage:
            'You must complete all of the application steps before reviewing your profile.'
        });
      } else {
        this.setState({ currentStep: currentStep + 1 }, () =>
          this.props.refetch()
        );
      }
    } else if (currentStep < 6) {
      this.setState({ currentStep: currentStep + 1 }, () =>
        this.props.refetch()
      );
    }
  };

  decrementStep = () => {
    const { currentStep } = this.state;
    if (currentStep > 0) {
      this.setState({ currentStep: currentStep - 1 }, () =>
        this.props.refetch()
      );
    } else if (currentStep === 0) {
      this.setState({ uberTerms: false, progressPage: true });
    }
  };

  goToApplication = step => {
    this.setState({ progressPage: false, currentStep: step });
  };

  getTitle = () =>
    [
      'Via Account',
      'Profile Photo',
      "Driver's License",
      'TLC License',
      'Social Security',
      'Review Profile',
      'Application Complete'
    ][this.state.currentStep];

  readStepValues = () => {
    console.log(this.props.location.search);
    const values = qs.parse(this.props.location.search);
    console.log(values);
    console.log(this.props.location.pathname);

    if (this.props.location.pathname === '/applyMobile' && values.step) {
      this.goToApplication(this.applyMobileSteps(values.step));
    }
    console.log(this.applyMobileSteps(values.step));
  };

  applyMobileSteps = step => {
    switch (step) {
      case 'viaAccount':
        return 0;
      case 'profilePhoto':
        return 1;
      case 'driversLicense':
        return 2;
      case 'workEligibility':
        return 3;
      case 'socialSecurity':
        return 4;
      case 'reviewProfile':
        return 5;
      case 'currentStep':
        return this.state.progress.nextStep;
    }
  };

  updateProgress = () => {
    const { currentUser } = this.props;
    const { bypassTlc } = this.state;
    const steps = [
      {
        name: 'Via Account',
        status: currentUser.existingUberPartner !== null
      }, // If the user has answered the question
      { name: 'Profile Photo', status: currentUser.uberProfileImage !== "https://x1.xingassets.com/assets/frontend_minified/img/users/nobody_m.original.jpg" }, // Does the image exist
      {
        name: "Driver's License",
        status:
          currentUser.driversLicenseImage &&
          currentUser.driversLicenseNumber
      }, // Does the image exist or user has no tlc
      {
        name: 'TLC License',
        status:
          (currentUser.employmentEligibilityImage &&
            currentUser.tlcNumber) ||
          bypassTlc
      }, // Does the image exist
      {
        name: 'Social Security',
        status: currentUser.ssn
      }, // Does the image exist
      {
        name: 'Review Profile',
        status: currentUser.status === 'signed_up'
      }
    ];
    const done = steps.slice(0, 5).every(item => item.status);
    const nextStep = steps.findIndex(element => !element.status);
    const started = !steps.every(item => !item.status);
    this.setState(
      {
        progress: {
          steps,
          nextStep: nextStep === -1 ? 6 : nextStep,
          started
        },
        progressMessage: started ? continueMessage : startMessage,
        done
      },
      () => {
        this.readStepValues();
      }
    );
  };

  bypassTlcUpload = bypass => {
    this.setState({ bypassTlc: bypass }, () => this.updateProgress());
  };

  render() {
    const { currentUser, refetch, loadUser } = this.props;
    const {
      currentStep,
      progressPage,
      progressMessage,
      progressTitle,
      progress,
      uberTerms,
      done,
      bypassTlc
    } = this.state;

    const uberUrl = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(
      currentUser ? currentUser.email : null
    )}`;

    return (
      <div
        id="apply-body"
        className={`apply__body container ${
          progressPage ? 'apply__body--progress' : ''
        } ${
          ((currentStep === 0 && uberTerms) || currentStep === 5) &&
          !progressPage
            ? 'apply__body--tall-footer'
            : ''
        }`}
        style={
          this.props.location.pathname.includes('Mobile') && progressPage
            ? { marginBottom: '88px', marginTop: '0' }
            : this.props.location.pathname.includes('Mobile') &&
              currentStep === 5
            ? { marginBottom: '0', paddingBottom: '88px' }
            : this.props.location.pathname.includes('Mobile')
            ? { marginBottom: '88px' }
            : null
        }>
        {progressPage ? (
          <Progress
            title={progressTitle}
            message={progressMessage}
            currentUser={currentUser}
            goToApplication={this.goToApplication}
            progress={progress}
            done={done}
            history={this.props.history}
          />
        ) : (
          <Fragment>
            <ProgressHeader
              title={this.getTitle()}
              currentStep={currentStep}
              currentUser={currentUser}
              decrementStep={this.decrementStep}
              goToSaved={this.goToSaved}
              uberTerms={uberTerms}
              history={this.props.history}
            />
            <SectionSelector
              goToUberTerms={this.goToUberTerms}
              loadUser={loadUser}
              setStep={this.setStep}
              updateButtonStatus={this.updateButtonStatus}
              currentStep={currentStep}
              currentUser={currentUser}
              uberUrl={uberUrl}
              refetch={refetch}
              uberTerms={uberTerms}
              decrementStep={this.decrementStep}
              incrementStep={this.incrementStep}
              toggleUberTerms={this.toggleUberTerms}
              title={this.getTitle()}
              bypassTlcUpload={this.bypassTlcUpload}
              bypassTlc={bypassTlc}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

const continueMessage =
  'It seems you have started the application form before. Your progress has been saved and you can continue where you left off.';
const startMessage =
  'You will need to go through the following steps. Your progress will be saved automatically. Click on Start Application.';

export default ApplyContainer;



// WEBPACK FOOTER //
// ./src/components/NycApply/ApplyContainer.js